export default __webpack_public_path__ + "static/media/O-155.9ff69cdb.png";